import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=79f6ed7c&scoped=true&"
import script from "./pricing.js?vue&type=script&lang=js&"
export * from "./pricing.js?vue&type=script&lang=js&"
import style0 from "./pricing.css?vue&type=style&index=0&id=79f6ed7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f6ed7c",
  null
  
)

export default component.exports